module.exports = __webpack_public_path__ + "img/water_shut_off.afba7543.svg";